import { render, staticRenderFns } from "./ModalCadastroRegistraEntrada.vue?vue&type=template&id=b1375fac"
import script from "./ModalCadastroRegistraEntrada.vue?vue&type=script&lang=js"
export * from "./ModalCadastroRegistraEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports